import { pascalCase } from "scule";
import { createError } from "#imports";

export function getBlockComponentName ( blockTypeAlias: string ): string {
  if ( !blockTypeAlias ) {
    throw createError( "No block type alias given" );
  }

  let name: string = blockTypeAlias;

  const suffixesToRemove = ["Block", "_Content"];
  for ( const suffix of suffixesToRemove ) {
    if ( name.endsWith( suffix ) && name.toUpperCase() !== suffix.toUpperCase() ) {
      name = name.slice( 0, -suffix.length );
    }
  }

  name = pascalCase( name );

  if ( !name.startsWith( "Block" ) || name === "Block" ) {
    name = "Block" + name;
  }

  return name;
}
